"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var TRANSLATION_MULTIPLE_REGISTER_SUCCESS = exports.TRANSLATION_MULTIPLE_REGISTER_SUCCESS = "TRANSLATION_MULTIPLE_REGISTER_SUCCESS";

var translationMultipleRegister_success = exports.translationMultipleRegister_success = function translationMultipleRegister_success(trm) {
	return {
		type: TRANSLATION_MULTIPLE_REGISTER_SUCCESS,
		payload: {
			tr: trm.tr
		}
	};
};

var translationMultipleRegister = exports.translationMultipleRegister = function translationMultipleRegister(data) {
	return function (dispatch) {
		return new Promise(function (resolve) {
			dispatch(translationMultipleRegister_success(data));
			resolve();
		});
	};
};